import { render } from "./ReportBatchConfirm.vue?vue&type=template&id=261f3af1"
import script from "./ReportBatchConfirm.vue?vue&type=script&lang=js"
export * from "./ReportBatchConfirm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\ekk-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__